"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-unstable-nested-components */
const react_1 = __importStar(require("react"));
const AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const Slide_1 = __importDefault(require("@material-ui/core/Slide"));
const Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
const ArrowBack_1 = __importDefault(require("@material-ui/icons/ArrowBack"));
const OpenInNew_1 = __importDefault(require("@material-ui/icons/OpenInNew"));
const classnames_1 = __importDefault(require("classnames"));
const noop_1 = __importDefault(require("lodash/noop"));
const prop_types_1 = __importDefault(require("prop-types"));
const useModalState_1 = __importDefault(require("../../../hooks/useModalState"));
const useSearchFocusShortcut_1 = __importDefault(require("../../../hooks/useSearchFocusShortcut"));
const button_1 = __importDefault(require("../../material-button/button"));
const tooltip_1 = __importDefault(require("../../tooltip/tooltip"));
const confirmation_modal_1 = __importDefault(require("../confirmation-modal/confirmation-modal"));
require("../../../styles/components/modal/modal.less");
const DIVIDER_STYLE = { marginTop: 20 };
const FOOTER_DIVIDER_STYLE = { marginBottom: 20 };
function Modal(props) {
    const { isOpen, closeModal, onSubmit, onSubmitHover, title, message, cancelText, submitText, className, submitButtonClassName, submitButtonType, submitButtonDisabled, cancelButtonType, showCancel, hideFooter, hideHeader, showHeaderCloseButton, cancelVariant, onCancel, customFooter, useBackButton, submitTooltip, isLoading, fullScreen, fullScreenOption, newTabLink, useTransition, modalEnteredEvent, unsavedChangesText, showUnsavedChanges, discardWarningMsg, onCancelButtonClick, backgroundGreyed, headerToolbar, dividers, savingStatusComponent, submitButtonVariant, ...rest } = props;
    const [isFullScreen, setIsFullScreen] = (0, react_1.useState)(fullScreen || false);
    const { isOpen: isConfirmationModalOpen, closeModal: closeConfirmationModal, openModal: openConfirmationModal } = (0, useModalState_1.default)();
    const { addSearchFocusShortcut, removeSearchFocusShortcut } = (0, useSearchFocusShortcut_1.default)();
    const doCancelActions = (0, react_1.useCallback)(() => {
        if (showUnsavedChanges) {
            openConfirmationModal();
            return;
        }
        setIsFullScreen(fullScreen || false);
    }, [showUnsavedChanges, openConfirmationModal, fullScreen]);
    const handleCancelButtonClick = (0, react_1.useCallback)(() => {
        doCancelActions();
        if (onCancelButtonClick) {
            onCancelButtonClick();
        }
        closeModal();
    }, [doCancelActions, onCancelButtonClick, closeModal]);
    const onCloseModal = (0, react_1.useCallback)(() => {
        doCancelActions();
        if (onCancel) {
            onCancel();
            return;
        }
        closeModal();
    }, [doCancelActions, onCancel, closeModal]);
    const discardChanges = (0, react_1.useCallback)(() => {
        closeConfirmationModal();
        closeModal();
    }, [closeConfirmationModal, closeModal]);
    const toggleFullScreen = (0, react_1.useCallback)(() => setIsFullScreen((curr) => !curr), []);
    const Transition = (0, react_1.useMemo)(() => react_1.default.forwardRef((properties, ref) => (react_1.default.createElement(Slide_1.default, { direction: "down", ref: ref, ...properties, onEntered: modalEnteredEvent }))), [modalEnteredEvent]);
    const BackdropStyle = (0, react_1.useMemo)(() => ({ classes: { root: `backdrop-root ${backgroundGreyed ? 'greyed' : ''}` } }), [backgroundGreyed]);
    (0, react_1.useEffect)(() => {
        if (isOpen) {
            removeSearchFocusShortcut();
        }
        return () => {
            addSearchFocusShortcut();
        };
    }, [addSearchFocusShortcut, isOpen, removeSearchFocusShortcut]);
    const classes = { root: (0, classnames_1.default)('confirmation-dialog', className, { 'full-screen': isFullScreen }), paper: (0, classnames_1.default)('confirmation-dialog-paper', { dividers }) };
    const closeButton = showHeaderCloseButton ? react_1.default.createElement("span", { className: "material-icons close header-button", onClick: closeModal }, "close") : '';
    const submitButton = (react_1.default.createElement(button_1.default, { onClick: onSubmit, onMouseEnter: onSubmitHover, className: `confirmation-dialog-button submit ${submitButtonClassName}`, isLoading: isLoading, variant: submitButtonVariant, color: submitButtonType, disabled: submitButtonDisabled }, submitText));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dialog_1.default, { maxWidth: "lg", "aria-labelledby": "confirmation-dialog-title", open: isOpen, onClose: onCloseModal, classes: classes, fullScreen: isFullScreen, TransitionComponent: useTransition ? Transition : undefined, BackdropProps: BackdropStyle, ...rest },
            headerToolbar ? (react_1.default.createElement(AppBar_1.default, { className: "header-toolbar-container", component: "div" },
                react_1.default.createElement(Toolbar_1.default, { className: "header-toolbar" },
                    headerToolbar,
                    submitButton,
                    closeButton))) : '',
            !hideHeader ? (react_1.default.createElement(DialogTitle_1.default, { className: "dialog-title" },
                newTabLink && (react_1.default.createElement("a", { className: "new-tab-btn header-button", href: newTabLink, target: "_blank", rel: "noopener noreferrer" },
                    react_1.default.createElement(OpenInNew_1.default, { className: "material-icons" }))),
                fullScreenOption ? (react_1.default.createElement("img", { className: "full-screen-btn header-button", src: isFullScreen ? '/img/close-full-screen.svg' : '/img/open-in-full.svg', alt: "open in full", onClick: toggleFullScreen })) : '',
                !useBackButton ? closeButton : '',
                showHeaderCloseButton && useBackButton && (react_1.default.createElement(IconButton_1.default, { edge: "start", color: "inherit", "aria-label": "back-arrow", onClick: closeModal },
                    react_1.default.createElement(ArrowBack_1.default, null))),
                react_1.default.createElement("div", { className: "title" }, title))) : '',
            hideHeader && !headerToolbar ? closeButton : '',
            dividers ? react_1.default.createElement("hr", { className: "divider", style: DIVIDER_STYLE }) : null,
            react_1.default.createElement(DialogContent_1.default, { className: "dialog-content" }, message),
            dividers && (!hideFooter || customFooter) ? react_1.default.createElement("hr", { className: "divider divider-bottom", style: FOOTER_DIVIDER_STYLE }) : null,
            !hideFooter && !customFooter ? (react_1.default.createElement(DialogActions_1.default, { className: "dialog-actions" },
                savingStatusComponent,
                showUnsavedChanges && unsavedChangesText ? react_1.default.createElement("div", { className: "unsaved-changes" }, unsavedChangesText) : null,
                showCancel ? react_1.default.createElement(button_1.default, { className: "confirmation-dialog-button cancel", color: cancelButtonType, variant: cancelVariant, onClick: onCancelButtonClick ? handleCancelButtonClick : onCloseModal }, cancelText) : '',
                react_1.default.createElement(tooltip_1.default, { title: submitTooltip || '' },
                    react_1.default.createElement("div", null, submitButton)))) : customFooter),
        react_1.default.createElement(confirmation_modal_1.default, { isOpen: isConfirmationModalOpen, closeModal: closeConfirmationModal, confirmationMessage: (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("strong", null, "WARNING:"),
                ' You have unsaved changes',
                react_1.default.createElement("div", { className: "sure-question" }, discardWarningMsg))), cancelText: 'Discard', onCancel: discardChanges, submitText: 'Go Back', onSubmit: closeConfirmationModal })));
}
Modal.defaultProps = {
    submitButtonType: 'primary',
    cancelButtonType: 'primary',
    cancelVariant: undefined,
    showCancel: true,
    hideFooter: false,
    hideHeader: false,
    showHeaderCloseButton: true,
    cancelText: 'Cancel',
    submitText: 'Okay',
    submitButtonDisabled: false,
    className: '',
    submitButtonClassName: '',
    title: '',
    onSubmit: noop_1.default,
    onCancel: null,
    customFooter: null,
    submitTooltip: null,
    useBackButton: false,
    isLoading: false,
    useTransition: false,
    modalEnteredEvent: undefined,
    unsavedChangesText: undefined,
    disableBackdropClick: false,
    showUnsavedChanges: false,
    discardWarningMsg: 'Your changes will be lost if you leave.',
    fullScreenOption: false,
    newTabLink: null,
    onSubmitHover: noop_1.default,
    onCancelButtonClick: null,
    backgroundGreyed: true,
    dividers: false,
    closeModal: noop_1.default,
    savingStatusComponent: null,
    submitButtonVariant: 'contained',
};
Modal.propTypes = {
    isOpen: prop_types_1.default.bool.isRequired,
    closeModal: prop_types_1.default.func,
    onCancel: prop_types_1.default.func,
    onSubmit: prop_types_1.default.func,
    title: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.element,
    ]),
    className: prop_types_1.default.string,
    submitButtonClassName: prop_types_1.default.string,
    message: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.element,
    ]).isRequired,
    cancelText: prop_types_1.default.string,
    submitText: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.element,
    ]),
    submitButtonType: prop_types_1.default.oneOf([
        'default',
        'primary',
        'secondary',
    ]),
    cancelButtonType: prop_types_1.default.oneOf([
        'default',
        'primary',
        'secondary',
    ]),
    cancelVariant: prop_types_1.default.oneOf([
        'outlined',
        'contained',
        'text',
    ]),
    submitButtonVariant: prop_types_1.default.oneOf([
        'outlined',
        'contained',
        'text',
    ]),
    disableBackdropClick: prop_types_1.default.bool,
    backgroundGreyed: prop_types_1.default.bool,
    showCancel: prop_types_1.default.bool,
    hideFooter: prop_types_1.default.bool,
    hideHeader: prop_types_1.default.bool,
    showHeaderCloseButton: prop_types_1.default.bool,
    submitButtonDisabled: prop_types_1.default.bool,
    customFooter: prop_types_1.default.element,
    submitTooltip: prop_types_1.default.string,
    useBackButton: prop_types_1.default.bool,
    isLoading: prop_types_1.default.bool,
    useTransition: prop_types_1.default.bool,
    modalEnteredEvent: prop_types_1.default.func,
    unsavedChangesText: prop_types_1.default.string,
    showUnsavedChanges: prop_types_1.default.bool,
    discardWarningMsg: prop_types_1.default.string,
    fullScreenOption: prop_types_1.default.bool,
    newTabLink: prop_types_1.default.string,
    onSubmitHover: prop_types_1.default.func,
    onCancelButtonClick: prop_types_1.default.func,
    dividers: prop_types_1.default.bool,
    savingStatusComponent: prop_types_1.default.element,
};
exports.default = Modal;
//# sourceMappingURL=modal.js.map